<template>
  <div>
    <div class="floor-page" id="floorpage">
      <MaskLoading :showMask="isGloabLoading" />
      <template v-if="floorData.length > 0">
        <div v-for="(item, idx) in floorData" :key="idx" :style="{
          marginTop:
            idx !== 0
              ? item.styleClass === 'commom-banner' ||
                item.styleClass === 'commom-five-content' ||
                item.styleClass === 'commom-banner-content' ||
                item.styleClass === 'businessSet-banner' ||
                item.styleClass === 'businessSet-banner-content' ||
                item.styleClass === 'common-small-banner-content'
                ? '.1rem'
                : ''
              : ''
        }">
          <Search v-if="item.styleClass === 'commom-top-search-content'" />
          <Swiper v-else-if="item.styleClass === 'commom-banner'" :floorData="item" />
          <Swiper2 v-else-if="item.styleClass === 'businessSet-banner'" :floorData="item" />

          <Select2 v-else-if="item.styleClass === 'commom-brandWall'" :floorData="item" />
          <FiveGrids v-else-if="item.styleClass === 'commom-five-content'" :floorData="item" />
          <SwiperSmall v-else-if="item.styleClass === 'commom-banner-content'" :floorData="item" />
          <SwiperSmall2 v-else-if="item.styleClass === 'businessSet-banner-content'" :floorData="item" />
          <SwiperSmall3 v-else-if="item.styleClass === 'common-small-banner-content'" :floorData="item" />

          <ThreeGrids v-else-if="item.styleClass === 'commom-three-item-content'" :floorData="item" />
          <FourGrids v-else-if="item.styleClass === 'commom-quadrangle1-content'" :floorData="item" />
          <OneToThree v-else-if="item.styleClass === 'commom-one-three'" :floorData="item" />
          <TwoToThree v-else-if="item.styleClass === 'commom-two-three'" :floorData="item" />
          <tabs v-else-if="item.styleClass === 'commom-navigation-bar'" :floorData="item" />

          <couponArea v-else-if="item.styleClass === 'commom-box'" :floorData="item" />

          <DivideTwo v-else-if="item.styleClass === 'commom-two-content'" :floorData="item" />
          <FlowList v-else-if="item.styleClass === 'commom-three-waterfall-content'" :floorData="item" />
          <FlowList2 v-else-if="item.styleClass === 'commom-three-waterfall-content2'" :floorData="item" />
          <rechargeFourGird v-else-if="item.styleClass === 'commom-quadrangle1-content-2'" :floorData="item" />
          <FourGrids2 v-else-if="item.styleClass === 'common-four-grid'" :floorData="item" />
          <TwoWaterfall v-else-if="item.styleClass === 'common-two-waterfall-content'" :floorData="item" />
        </div>
      </template>
    </div>
    <template v-if="floorData.length > 0">
      <div v-for="(item, idx) in floorData" :key="idx" :style="{
        marginTop:
          idx !== 0
            ? item.styleClass === 'commom-banner' ||
              item.styleClass === 'commom-five-content' ||
              item.styleClass === 'commom-banner-content' ||
              item.styleClass === 'businessSet-banner' ||
              item.styleClass === 'businessSet-banner-content' ||
              item.styleClass === 'common-small-banner-content'
              ? '.1rem'
              : ''
            : ''
      }">
        <img class="coupon" v-if="item.styleClass === 'commom-floating-icon'" :src="item.data[0].imageUrl"
          @click="!$isIframe ? goCoupon(item) : ''" alt="" />
      </div>
    </template>
  </div>
</template>

<script>
import { getFloorData, getCouponPageFloorInfo, getMarketSite } from '@/api/floor'
import Search from '@/components/Floors/search'
import Swiper from '@/components/Floors/swiper'
import FiveGrids from '@/components/Floors/fiveGrids'
import SwiperSmall from '@/components/Floors/swiperSmall'
import SwiperSmall2 from '@/components/Floors/swiperSmall2'
import SwiperSmall3 from '@/components/Floors/swiperSmall3'
import Swiper2 from '@/components/Floors/swiper2'
import ThreeGrids from '@/components/Floors/threeGrids'
import FourGrids from '@/components/Floors/fourGrids'
import OneToThree from '@/components/Floors/oneToThree'
import TwoToThree from '@/components/Floors/twoToThree'
import DivideTwo from '@/components/Floors/divideTwo'
import FlowList from '@/components/Floors/flowList'
import FlowList2 from '@/components/Floors/flowList2'
import Select2 from '@/components/Floors/select2.vue'
import tabs from '@/components/Floors/tabs'
import couponArea from '@/components/Floors/couponArea'
import rechargeFourGird from '@/components/Floors/rechargeFourGird'
import FourGrids2 from '@/components/Floors/fourGrids2'
import TwoWaterfall from '@/components/Floors/twoWaterfall'
export default {
  name: 'FloorPage',
  components: {
    Swiper,
    FiveGrids,
    SwiperSmall,
    SwiperSmall2,
    SwiperSmall3,
    Swiper2,
    ThreeGrids,
    FourGrids,
    OneToThree,
    TwoToThree,
    DivideTwo,
    FlowList,
    FlowList2,
    Search,
    Select2,
    tabs,
    couponArea,
    rechargeFourGird,
    FourGrids2,
    TwoWaterfall
  },
  data: () => {
    return {
      pageId: '',
      isGloabLoading: false,
      floorData: [],
      show: false // 弹窗确认填写工号
    }
  },
  created () {
    const { pageId, type } = this.$route.query
    this.pageId = pageId
    if (pageId) {
      if (type === '1') {
        // 1 领取优惠券配置专用接口
        this.getCouponFloorData(pageId)
      } else if (type === '2') {
        // 获取话费充值页面
        this.getMarketSiteData(pageId)
      } else {
        // 获取首页渲染数据
        this.getFloorData(pageId)
      }
    }
  },
  methods: {
    goCoupon (a) {
      if (a.data[0].titleUrl) window.location.href = a.data[0].titleUrl
    },
    getMarketSiteData (pageId) {
      this.isGloabLoading = true
      getMarketSite({
        pageId
      })
        .then(res => {
          this.isGloabLoading = false
          const result = res.data || []

          const navArr = []
          let navIndex = '999'
          result.forEach((item, index) => {
            // 获取导航数据，循环并获取类型为commom-box的标题和id
            if (item.styleClass === 'commom-navigation-bar') {
              // 当判断有导航层时
              navIndex = index
            }
            if (navIndex !== '999' && item.styleClass === 'commom-box') {
              navArr.push({
                label: item.floorTitle,
                value: item.data[0].floorId
              })
            }
          })

          if (navIndex !== '999') {
            this.$set(result[navIndex], 'navData', navArr)
          }

          this.floorData = result
        })
        .catch(() => {
          this.isGloabLoading = false
        })
    },
    getCouponFloorData (pageId) {
      // 领取优惠券配置专用接口
      this.isGloabLoading = true
      getCouponPageFloorInfo({
        pageId
      })
        .then(res => {
          this.isGloabLoading = false
          const result = res.data || []

          const navArr = []
          let navIndex = '999'
          result.forEach((item, index) => {
            // 获取导航数据，循环并获取类型为commom-box的标题和id
            if (item.styleClass === 'commom-navigation-bar') {
              // 当判断有导航层时
              navIndex = index
            }
            if (navIndex !== '999' && item.styleClass === 'commom-box') {
              navArr.push({
                label: item.floorTitle,
                value: item.data[0].floorId
              })
            }
          })

          if (navIndex !== '999') {
            this.$set(result[navIndex], 'navData', navArr)
          }

          this.floorData = result
        })
        .catch(() => {
          this.isGloabLoading = false
        })
    },
    // 获取首页渲染数据
    getFloorData (pageId) {
      this.isGloabLoading = true
      getFloorData({
        pageId
      })
        .then(res => {
          this.isGloabLoading = false
          const result = res.resultObj || []
          this.floorData = result
          if (this.$route.name === 'Coupon' && res.pageTile) {
            document.title = res.pageTile
          }
        })
        .catch(() => {
          this.isGloabLoading = false
        })
    },
    isShowGloabLoading (val) {
      this.isGloabLoading = val
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon {
  position: fixed;
  bottom: 0.5rem;
  right: 0.2rem;
  width: 0.5rem;
  height: 0.5rem;
  z-index: 9999;
}

.floor-page {
  position: relative;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-color: #f3f3f3;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 20px;
}
</style>
